export const MORE_INFO_LABELS = {
  TITLE: "Mais informações",
  OPERATOR_NAME: "Nome do operador",
  LAST_UPDATED: "Última alteração",
  EMPTY_STATE:
    "Este NSU foi lançado antes destas informações passarem a ser trazidas do VAR, então elas ainda não estão no Portal.",
  FETCH_ACTION: "Buscar no VAR",
  FETCHING: "Buscando...",
  OPERATOR_NOT_REGISTERED:
    "A última alteração foi preenchida, mas o operador não está mais no cadastro do VAR, então o nome não pôde ser obtido.",
  FETCH_ERROR_DEFAULT: "Não foi possível buscar as informações no VAR.",
} as const;

export const MORE_INFO_MESSAGES = {
  FETCH: {
    SUCCESS: {
      variant: "success",
      description: "Informações buscadas no VAR com sucesso!",
      duration: 5000,
    },
    EMPTY: {
      description: "O VAR não tem essas informações para este NSU.",
      duration: 5000,
    },
  },
} as const;

export const ROW_ACTIONS_LABELS = {
  MENU_ARIA: "Abrir menu de ações",
  DOWNLOAD: "Download",
  HISTORY: "Histórico",
  DOWNLOAD_DIALOG_TITLE: "Download das evidências",
  HISTORY_DIALOG_TITLE: "Histórico de Ajustes NSU",
} as const;

export const HISTORY_LABELS = {
  EMPTY: "Nenhum ajuste encontrado",
  ID: "ID:",
  ADJUSTMENT_VALUE: "Valor do Ajuste:",
} as const;

export const FILE_MESSAGES = {
  DOWNLOAD_ERROR: {
    title: "Erro",
    description: "Não foi possível baixar o arquivo.",
    variant: "destructive",
  },
  DELETE_SUCCESS: {
    title: "Sucesso",
    description: "Arquivo excluído com sucesso.",
    variant: "success",
  },
  DELETE_ERROR: {
    title: "Erro",
    description: "Não foi possível excluir o arquivo.",
    variant: "destructive",
  },
} as const;
